import { Component, OnDestroy, OnInit } from "@angular/core";
import { ActivatedRoute, Router } from "@angular/router";
import { combineLatest, Subscription } from "rxjs";
import { Context } from "../../../models/context";

type TemplateTab = "messages" | "certificates";

@Component({
  selector: "app-templates-page",
  templateUrl: "./templates.component.html",
  styleUrls: ["./templates.component.scss"],
})
export class TemplatesComponent implements OnInit, OnDestroy {

  public context: Context = new Context();
  public serviceId: string;
  public activeTab: TemplateTab = "certificates";
  public tabs = [
    { id: "certificates", name: "Certificates" },
    { id: "messages", name: "Messages" },
  ];
  public tabBaseUrl: string;

  private subscription = new Subscription();

  constructor(private route: ActivatedRoute, private router: Router) {}

  public ngOnInit(): void {
    this.subscription.add(
      combineLatest([
        this.route.paramMap,
        this.route.data,
        this.route.queryParamMap,
      ]).subscribe(([params, data, query]) => {
        this.serviceId = params.get("serviceId");
        if (this.serviceId) {
          this.tabBaseUrl = `/services/${this.serviceId}/templates`;
        }
        const tabParam = params.get("tab") || query.get("tab") || data?.defaultTab;
        this.setActiveTab(tabParam as string);
      }),
    );
  }

  public ngOnDestroy(): void {
    this.subscription.unsubscribe();
  }

  public isActive(tab: TemplateTab): boolean {
    return this.activeTab === tab;
  }

  private setActiveTab(tab?: string): void {
    const targetTab: TemplateTab = tab === "messages" ? "messages" : "certificates";
    this.activeTab = targetTab;

    if (!this.serviceId) {
      return;
    }

    const canonicalBase = `/services/${this.serviceId}/templates`;
    const targetCommands = ["/services", this.serviceId, "templates", targetTab];
    const currentUrl = this.router.url;
    const isOnCanonicalPath = currentUrl.startsWith(canonicalBase);
    const isBaseWithoutTab = currentUrl === canonicalBase;

    if (!isOnCanonicalPath || (!tab && isBaseWithoutTab)) {
      this.router.navigate(targetCommands, { replaceUrl: true });
    }
  }
}
